import { RateGroupOptions } from '@mews-commander/data-access';
import { SelectField, SelectFieldProps } from '@mews-commander/form';
import { createOption } from '@mews-commander/ui';
import { lt, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const PaymentConfigurationOptionsField = (props: Omit<SelectFieldProps, 'options' | 'multiselect'>) => {
    const localizeText = useLocalizeText();

    const optionsFieldOptions = [
        createOption({
            value: RateGroupOptions.AutomaticDepositSettlement,
            label: localizeText({ textKey: TextKey.RateGroupOptionsAutomaticTaxDeposit }),
        }),
        createOption({
            value: RateGroupOptions.CreateSettlementTask,
            label: localizeText({ textKey: TextKey.RateGroupOptionsCreatePaymentTask }),
        }),
    ];

    return <SelectField label={lt('Options')} {...props} options={optionsFieldOptions} multiselect />;
};
